import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { ServiceGvariableProvider } from '../service-gvariable/service-gvariable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';

/*
  Generated class for the ServiceApiProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ServiceApiProvider {

  constructor(public http: Http, public servicegvariable:ServiceGvariableProvider) {
    console.log('Hello ServiceApiProvider Provider');
  }

  sort(sortby,sorttype)
  {
    if(sortby == "No" && sorttype == "No")
    { 
        let format = {Format:"No"};
        return format;
    }
    else
    {
        let format = {Format:{Sort:{SortBy:"",SortType:""}}};
        format.Format.Sort.SortBy = sortby;
        format.Format.Sort.SortType = sorttype;
        return format;
    }
  }

  search(searchval,searchby,searchtbl)
  {
    if(searchval == "No" && searchby == "No" && searchtbl == "No")
    { 
        let search = {Search:"No"};
        return search;
    }
    else if(searchby == "All" && searchtbl == "All")
    {
        let k = 0;
        
        
        
        let search = {Search:{Item:{Search:"",SearchBy:"All",SearchTbl:"All"}}};
        search.Search.Item.Search = searchval;
       
        return search;
    }
    else
    {
        let k = 0;
        
        let searchby_data=[];
        for(k=0;k<searchby.length;k++)
        {
          let searchby_array= {Key:""};
          searchby_array.Key = searchby[k];
          searchby_data.push(searchby_array);
          
        }
        let searchtbl_data=[];
        for(k=0;k<searchtbl.length;k++)
        {
          let searchtbl_array= {Key:""};
          searchtbl_array.Key = searchtbl[k];
          searchtbl_data.push(searchtbl_array);
          
        }
        
        let search = {Search:{Item:{Search:"",SearchBy:[],SearchTbl:[]}}};
        search.Search.Item.Search = searchval;
        search.Search.Item.SearchBy = searchby_data;
        search.Search.Item.SearchTbl = searchtbl_data;
        return search;
    }
  }

  requestitem(table,column,value,tblkey,fktbl,fkkey)
  {
    let item = "";
    let foreign = "";
    let k = 0;
    let table_data=[];
    let column_data=[];
    let value_data=[];
    let tblkey_data=[];
    let fktbl_data=[];
    let fkkey_data=[];
    
    if(table == "All" && column == "All" && value == "All")
    { 
        item = "All";
     
    }
    else
    {
        for(k=0;k<table.length;k++)
        {
          let table_array= {Tbl:""};
          table_array.Tbl = table[k];
          table_data.push(table_array);
          
        }

       
        for(k=0;k<column.length;k++)
        {
          let column_array= {Col:""};
          column_array.Col = column[k];
          column_data.push(column_array);
          
        }

        
        for(k=0;k<value.length;k++)
        {
          let value_array= {Val:""};
          value_array.Val = value[k];
          value_data.push(value_array);
          
        }
    }
  
    if(tblkey == "No" && fktbl == "No" && fkkey == "No")
    { 
      foreign = "No";
     
    }
    else
    {
        for(k=0;k<tblkey.length;k++)
        {
          let tblkey_array= {Key:""};
          tblkey_array.Key = tblkey[k];
          tblkey_data.push(tblkey_array);
          
        }

        
        for(k=0;k<fktbl.length;k++)
        {
          let fktbl_array= {Tbl:""};
          fktbl_array.Tbl = fktbl[k];
          fktbl_data.push(fktbl_array);
          
        }

        
        for(k=0;k<fkkey.length;k++)
        {
          let fkkey_array= {Key:""};
          fkkey_array.Key = fkkey[k];
          fkkey_data.push(fkkey_array);
          
        }
    }
    if(item == "All" && foreign !="No")
    {
        let request = {Request:{Item:"All",ForeignKey:{TblKey:[],FkTbl:[],FkKey:[]}}};
        
        request.Request.ForeignKey.TblKey = tblkey_data;
        request.Request.ForeignKey.FkTbl = fktbl_data;
        request.Request.ForeignKey.FkKey = fkkey_data;
        return request;
    }
    else if(item == "All" && foreign =="No")
    {
        let request = {Request:{Item:"All",ForeignKey:"No"}};
        
        return request;
    }
    else  if(item != "All" && foreign =="No")
    {
        let request = {Request:{Item:{Table:[],Column:[],Value:[]},ForeignKey:"No"}};
        request.Request.Item.Table = table_data;
        request.Request.Item.Column = column_data;
        request.Request.Item.Value = value_data;
      
        return request;
    }
    else
    {
        let request = {Request:{Item:{Table:[],Column:[],Value:[]},ForeignKey:{TblKey:[],FkTbl:[],FkKey:[]}}};
        request.Request.Item.Table = table_data;
        request.Request.Item.Column = column_data;
        request.Request.Item.Value = value_data;
        request.Request.ForeignKey.TblKey = tblkey_data;
        request.Request.ForeignKey.FkTbl = fktbl_data;
        request.Request.ForeignKey.FkKey = fkkey_data;
        return request;
    }
    
  }

  rangesearch(start,end,col,table)
  {
    let range = {Range:{Item:{Start:"",End:"",Column:"",Table:""}}};
    
        range.Range.Item.Table = table;
        range.Range.Item.Column = col;
        range.Range.Item.Start = start;
        range.Range.Item.End = end;
        return range;
  }

  json_readdata(data,param)
  {
    let json_format={Format:""};
    let json_request={Request:""};
    let json_search={Search:""};
    let json_range={Range:""};
    if(param == "1")
    {
      Object.keys(data).forEach(function(key) {
        if(data.hasOwnProperty('Format'))
        {
          if(key == "Format")
          {
            json_format.Format = data[key];
          }
        }
        else
        {
            json_format.Format = "No";
        }
        if(data.hasOwnProperty('Search'))
        {
          if(key == "Search")
          {
            json_search.Search = data[key];
          }
        }
        else
        {
          json_search.Search = "No";
        }

        if(data.hasOwnProperty('Request'))
        {
          if(key == "Request")
          {
            json_request.Request = data[key];
          }
        }
        else
        {
          json_request.Request = "No";
        }
       
        if(data.hasOwnProperty('Range'))
        {
          if(key == "Range")
          {
            json_range.Range = data[key];
          }
        }
        else
        {
          json_range.Range = "No";
        }
        
      })
    
    }
   
    return Object.assign(json_format,json_request,json_search,json_range);
  }

  readdata(data,table,param,page) {
    return new Promise((resolve, reject) => {
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');

      this.http.post(this.servicegvariable.URL+'/api/functions/readone.php?tbl='+table+'&param='+param+'&page='+page, JSON.stringify(data), {headers: headers})
      .timeout(5000)
      .subscribe(res => {
          resolve(res.json());
        }, (err) => {
           reject(err);
        });

    });
  }

  insertdata(table,data) {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post(this.servicegvariable.URL+'/api/functions/insert.php?tbl='+table, JSON.stringify(data), {headers: headers})
        .timeout(5000)  
        .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
    });
    
  }


  updatedata(table,refer_column,refer_val, data) {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post(this.servicegvariable.URL+'/api/functions/update.php?tbl='+table+'&item='+refer_column+'&val='+refer_val, JSON.stringify(data), {headers: headers})
        .timeout(5000)  
        .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
    });
    
  }
  validatedata(table,data) {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post(this.servicegvariable.URL+'/api/functions/validate.php?tbl='+table, JSON.stringify(data), {headers: headers})
        .timeout(5000)  
        .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
    });
    
  }

  deletedata(table,refer_column,refer_val) {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.get(this.servicegvariable.URL+'/api/functions/delete.php?tbl='+table+'&item='+refer_column+'&val='+refer_val)
        .timeout(5000)  
        .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
    });
  }

  possalesdata(data) {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post(this.servicegvariable.URL+'/api/functions/pos_sales.php', JSON.stringify(data), {headers: headers})
        .timeout(5000)  
        .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
    });
  }

  poslaybydata(data) {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post(this.servicegvariable.URL+'/api/functions/layby.php', JSON.stringify(data), {headers: headers})
        .timeout(5000)  
        .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
    });
  }

  serverdatetime() {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');
        this.http.get(this.servicegvariable.URL+'/api/functions/datetime.php')
        .timeout(5000)  
        .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
    });
  }

  refund(data) {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post(this.servicegvariable.URL+'/api/functions/refund.php', JSON.stringify(data), {headers: headers})
        .timeout(5000)  
        .subscribe(res => {
            resolve(res.json());
          }, (err) => {
            reject(err);
          });
    });
  }


  displayErrorMessage(status){
    let errorMessage = "";

    if (status == "2")
      errorMessage = "Unable to Connect to Database";
    else if (status == "3")
      errorMessage = "Table Name Not Found";
    else if (status == "4")
      errorMessage = "No Data Found";
    else if (status == "5")
      errorMessage = "Invalid Column Assigned";
    else if (status == "6")
      errorMessage = "Failed to Update Data";   
    else  
      errorMessage = status;

    return errorMessage;
  }

  // [CXY:14/06/2020:CR/MPOS/20-01]:Added
  validateWantokPayment(data) {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post(this.servicegvariable.WantokGiftCard_URL+'/api/payment-gateway/wantokpayment_v.php', JSON.stringify(data), {headers: headers})
        .timeout(5000)  
        .subscribe(res => {
          resolve(res.json());
        }, (err) => {
          reject(err);
        });
    });
  }

  // [CXY:14/06/2020:CR/MPOS/20-01]:Added
  payWantokPayment(data) {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post(this.servicegvariable.WantokGiftCard_URL+'/api/payment-gateway/wantokpayment_i.php', JSON.stringify(data), {headers: headers})
        .timeout(5000)  
        .subscribe(res => {
          resolve(res.json());
        }, (err) => {
          reject(err);
        });
    });
  }

  // [CXY:03/07/2020:CR/MPOS/20-01]:Added
  checkWantokGiftCardBalance(data) {
    return new Promise((resolve, reject) => {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json');

        this.http.post(this.servicegvariable.WantokGiftCard_URL+'/api/payment-gateway/getCardBalance.php', JSON.stringify(data), {headers: headers})
        .timeout(5000)  
        .subscribe(res => {
          resolve(res.json());
        }, (err) => {
          reject(err);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/service-api/service-api.ts